module.exports = __webpack_public_path__ + "img/Jennifer&Marcus-14.90996aa5.jpg";